export default "__VITE_ASSET__CHguhuau__"